import { Breadcrumbs as BreadcrumbsPrimitive } from '@systemeio/components'
import type { ReactNode } from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

interface BreadcrumbsData {
  caption: ReactNode
  href?: string
  isStatic?: boolean
}

interface BreadcrumbsProps {
  data: BreadcrumbsData[]
  isFetching?: boolean
}

function Breadcrumbs({ data, isFetching }: BreadcrumbsProps) {
  const items = data.map<BreadcrumbsPrimitive.ItemData>(({ caption, href, isStatic }) => {
    return {
      href,
      label: caption,
      linkProps: href
        ? {
            render: <LinkWithoutPrefetch href={href} />,
          }
        : undefined,
      loading: Boolean(isFetching && !isStatic),
    }
  })

  return <BreadcrumbsPrimitive className="font-normal" items={items} />
}

export { Breadcrumbs }
export type { BreadcrumbsData, BreadcrumbsProps }
